// dayjs 전역 설정 (locale: ko, plugins: duration) — 반드시 최상단에 위치
import 'utils/dayjs';

// 기본 CSS 파일들
import 'styles/css/font.css';
import 'styles/css/common.css';

// react-loading-skeleton CSS
import 'react-loading-skeleton/dist/skeleton.css';

// react-lazy-load-image-component CSS
import 'react-lazy-load-image-component/src/effects/opacity.css';

// swiper CSS
import 'swiper/swiper.scss';

import { registerDefaultAxiosSessionExpiry } from 'apis/utils/registerDefaultAxiosSessionExpiry';

registerDefaultAxiosSessionExpiry();

async function init() {
  const { render } = await import('./render');
  const { initMonitoring } = await import('./monitoring');

  render();
  initMonitoring();
}

init();
